import React, { Component } from "react";
import { Grid, Typography } from "@material-ui/core";
import { connect } from "react-redux";

import { webFont, textBlack, textGrey } from "../../config/theme";
import { client } from "../../config/apollo";
import { DISHES_BY_CHEF, FIND_DISHES } from "../../graphql/queries/dishes";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import SingleDish from "./SIngleDish";

class DList extends Component {
  state = {
    dishesList: [],
    loading: false
  };

  fetchDishes = () => {
    const { pageSize, filters, next, previous, type } = this.props;

    switch (type) {
      default:
        return;

      case "dishesByChef":
        this.getDishesByChef(filters.chefId, pageSize, next, previous);
        break;
      case "all":
        this.fetchAll();
        break;
    }
  };
  componentDidMount() {
    this.fetchDishes();
  }
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.fetchDishes();
    }
  }
  handleClick = dish => {
    const { isChef, userId, history, viewAsDiner } = this.props;

    if (isChef && userId === dish.chefId && !viewAsDiner) {
      history.push("/home/add-dish", { dish });
    } else {
      history.push({
        pathname: "/home/dish-details",
        search: `dishId=${dish.id}`,
        state: { dishId: dish.id }
      });
    }
  };

  fetchAll = () => {
    this.setState({ loading: true });
    if (this.props.filters) {
      if (this.props.filters.hasOwnProperty("search") && !this.props.filters.hasOwnProperty('dishes')) {
        this.props.filters.searchType = "DISH_NAME";
      }
    }
    client
      .query({
        query: FIND_DISHES,
        variables: {
          filters: this.props.filters,
          includeChefs: true,
          pageSize: 20,
          next: null,
          previous: null
        },
        fetchPolicy: "network-only"
      })
      .then(resp => {
        this.setState({ loading: false });

        if (resp.data) {
          if (resp.data.findDishes) {
            this.setState({ dishesList: resp.data.findDishes.dishes });
          }
        }
      })
      .catch(err => {
        console.error("CHEF Dishes: ", err);
        this.setState({ loading: false });
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
      });
  };
  getDishesByChef = (chefId, pageSize, previous, next) => {
    client
      .query({
        query: DISHES_BY_CHEF,
        variables: {
          chefId,
          pageSize,
          next,
          previous
        },
        fetchPolicy: "network-only"
      })
      .then(resp => {
        if (resp.data) {
          if (resp.data.dishesByChef) {
            this.setState({
              dishesList: resp.data.dishesByChef.dishes,
              loading: false
            }, () => {
              if (this.props.selectedDishId) {
                if (!this.props.isCalledClick) {
                  this.props.callClick(this.props.selectedDishId);
                }
              }
            });
          }
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        console.log(JSON.parse(JSON.stringify(err)));
      });
  };

  render() {
    let { dishesList } = this.state;
    const { cart } = this.props;
    let fDishes = null;
    dishesList = dishesList.filter(dish => dish.isDraft === false);
    if (dishesList.length > 0) {
      fDishes = dishesList.map(dish => {
        return (
          <SingleDish
            dish={dish}
            cart={cart}
            handleClick={this.handleClick}
            key={dish.id}
            viewAsDiner={this.props.viewAsDiner}
            refreshBookNow={this.props.refreshBookNow ? this.props.refreshBookNow : () => {}}
          />
        );
      });
    } else {
      return (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
          No dishes added yet.
        </div>
      );
    }
    const filters =
      this.props.type === "dishesByChef" ? { search: "" } : { search: "a" };
    return (
      <Grid className="dish-container" container>
        {this.state.loading && (
          <Grid item md={12} style={{ textAlign: "center" }}>
            <CircularProgress color="primary" />
          </Grid>
        )}
        <div className="dish-conatiner-row">
          {fDishes}
        </div>
        {this.state.dishesList.length <= 0 &&
          !this.state.loading &&
          this.props.searching && (
            <Grid container alignItems="center" justify="center">
              <Typography
                align="center"
                variant="body1"
                style={{ textAlign: "center" }}
                gutterBottom={true}
                noWrap={true}
                color="primary"
              >
                Dishes not found!
              </Typography>
            </Grid>
          )}

      {/*  <Grid container alignItems="center" justify="center">
          <Button
            variant="outlined"
            color="primary"
            style={style.showBtn}
            onClick={() => this.props.history.push("/home/dish-search", filters)}
          >
            Show All
          </Button>
        </Grid>*/}
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    cart: state.bookings.cart,
    selectedChefid: state.bookings.selectedChefId
  };
};

/*const DListWithData = compose(
	graphql(DISHES_BY_CHEF, {name: 'dishesByChef'}),
	graphql(FIND_DISHES, {name: 'findDishes'}),
)(DList);*/

const DishesList = connect(mapStateToProps)(DList);

export default DishesList;

const style = {
  avatarImg: {
    width: '97%',
    height: 210,
    borderRadius: 5
  },
  avatarImgMob: {
    width: 320,
    height: 320,
    borderRadius: 5,
    marginLeft: 40
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    marginLeft: 80,
    weight: 800,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    paddingLeft: 25
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
    paddingLeft: 20
  },
  dishName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    maxWidth: 400,
    paddingLeft: 20,
    marginTop: 10
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: "none",
    marginTop: 30,
    fontFamily: webFont
  }
};
